import { gql } from '@apollo/client';

export const GET_STD_TIME_TABLE = gql`
  query getStudentPapers {
    getStudentPapers {
      _id
      indexNumber
      name
      allocatedRoom {
        name
        building
        college
        floor
        qrCodeImageUrl
      }
      paper {
        session
        date
        session
        courseName
        courseCode
        time
        examType
        semester
      }
    }
  }
`;
